module.exports = {
  project: (Api, $stateParams) ->
    return Api.Project.get({ id: $stateParams.projectId }).$promise

  allWorkflows: (Api, $stateParams) ->
    return Api.Workflow.query({project: $stateParams.projectId}).$promise
}
